import React from 'react';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

import { useDispatch, useSelector } from 'react-redux';
import State from '../states/State';
import slice from '../states/shell/slice';
import { peScrollIntoView } from '../helpers/scrollHelper';
import useStyles from '../styles/styles';


type PeStepItemProps = {
  readonly id: number,
  readonly name: string,
  readonly status: number,
  readonly current?: boolean,
  readonly last?: boolean,
  readonly onClick?: void,
};
const PeStepItem: React.FC<PeStepItemProps> = ({ id, status, current, name, last }) => {
  const classes = useStyles();

  const state = useSelector((state: State) => {
    const shell = state.shell
    return ({
      shell
    });
  });

  const dispatch = useDispatch();

  const handleClick = () => {
    const { doneStep, steps } = state.shell.step;
    if (doneStep === steps.length) {
      return;
    }
    if (id > doneStep) {
      return;
    }
    // Set step = activeStep
    peScrollIntoView('#step-' + id, 'start');
    dispatch(slice.actions.updateCurrentStep(id));
  }

  var colorProgress, label, icon;
  switch (status) {
    case 0:
      colorProgress = '#D3D3D3';
      label = 'Waiting';
      icon = <AccessTimeIcon color="inherit" fontSize="large" className={classes.PeStep_icon} />;
      break;
    case 1:
      colorProgress = '#1976D2';
      label = 'In Progress';
      icon = <PlayCircleFilledIcon color="inherit" fontSize="large" className={classes.PeStep_icon} />;
      break;
    default:
      colorProgress = '#57BC64';
      label = 'Done';
      icon = <CheckCircleIcon color="inherit" fontSize="large" className={classes.PeStep_icon} />;
      break;
  }

  return <div className={classes.item}>
    <div className={classes.itemMain}>
      <div className={classes.itemInfo}>
        <span className={classes.itemProgress} style={{ color: colorProgress }}>{label}</span>
        <p className={classes.itemName} style={current ? { color: '#787682', fontWeight: "bold" } : { color: '#D3D3D3' }}>{name}</p>
      </div>
      <div className={current ? 'pulsate-fwd' : ''} style={{ color: colorProgress }} onClick={handleClick}>{icon}</div>
    </div>
    {!last && <div className={classes.itemSub}></div>}
  </div>
}

type PeStepProps = {};
const PeStep: React.FC<PeStepProps> = props => {
  const classes = useStyles();

  const state = useSelector((state: State) => {
    const shell = state.shell
    return ({
      shell
    });
  });

  const { steps, currentStep, doneStep } = state.shell.step;

  return <div className={classes.PeStep_control}>
    <div className={classes.area}>
      {steps && steps.map((item) => {
        const status = currentStep === steps.length ? 2 : item.id === currentStep ? 1 : item.id <= doneStep ? 2 : 0;
        return <PeStepItem key={item.id}
          id={item.id}
          name={item.name}
          status={status}
          current={item.id === currentStep ? true : false}
          last={item.id === steps.length ? true : false} />
      })}
    </div>
  </div>
}

export default PeStep;